var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroceryDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.275,
    y: 0.275,
    width: 21.45,
    height: 21.45,
    rx: 10.725,
    stroke: "#4CAF50",
    strokeWidth: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#245anw3iaa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hf46un8sqb)",
    fill: "#4CAF50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.705 9.852.005.003V6.996H9.589v1.532a1.53 1.53 0 0 1 2.116 1.324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.117 9.943c0 .024.004.044.006.067l.57-.38a.236.236 0 0 1 .262 0l.576.384.576-.384a.237.237 0 0 1 .069-.03 1.057 1.057 0 0 0-2.059.343zM11.847 6.527l.707-.707h-1.926l-.707.707h1.926zM12.18 9.858l.181-.122 1.25-3.329-.489-.489-.942.943v2.997zM7.93 6.421a.236.236 0 0 1-.301.359.253.253 0 0 0-.317.03l-.006.006-.004.004a.273.273 0 0 0 .005.371c.006.006.042.047.088.102l.06.07a1.272 1.272 0 0 1 1.067.698l.446.948a1.51 1.51 0 0 1 .149-.165v-2.08l.003-.014a.23.23 0 0 1 .012-.062l.008-.022a.236.236 0 0 1 .046-.067l.109-.11-.007-.007.694-.707a.27.27 0 0 0 0-.377.255.255 0 0 0-.358 0l-.347.354a.236.236 0 0 1-.404-.165v-.943a.227.227 0 1 0-.454 0v.943a.236.236 0 0 1-.404.165l-.346-.354a.252.252 0 0 0-.36 0 .272.272 0 0 0-.002.377l.623.646zM10.766 4.883h2.12v.471h-2.12v-.471zM6.938 14.777a.759.759 0 0 0-.54.224l-.179.179a.235.235 0 0 1-.333 0L5.708 15a.764.764 0 0 0-1.305.54c.001.546.128 1.084.372 1.573l.082.165a.589.589 0 0 0 .795.264l.297-.149a.235.235 0 0 1 .21 0l.297.149a.59.59 0 0 0 .793-.265l.082-.165c.244-.488.37-1.026.371-1.571a.765.765 0 0 0-.764-.765zM14.641 10.498l-.576-.385-.471.314v7.18h.942c.39 0 .707-.316.707-.707v-6.63l-.34.228a.236.236 0 0 1-.262 0zM6.835 9.236l.612-.474.289.373-.608.47.05.063.524.349.576-.385a.236.236 0 0 1 .261 0l.125.083c.008-.056.02-.112.035-.167l-.601-1.28a.795.795 0 0 0-1.155-.3.816.816 0 0 0-.161 1.202l.053.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.074 10.498a.236.236 0 0 1-.261 0l-.577-.385-.576.384a.236.236 0 0 1-.261 0l-.576-.384-.577.384a.236.236 0 0 1-.261 0l-.576-.384-.576.384a.236.236 0 0 1-.262 0l-.34-.226v4.077c.552.134.94.628.942 1.196 0 .62-.145 1.23-.42 1.783l-.083.165a1.12 1.12 0 0 1-.069.116h5.52v-7.18l-.47-.315-.577.385zM16.459 4.868a1.04 1.04 0 0 0-.864-.458 1.07 1.07 0 0 0-.99.699l-1.725 4.59.478.32.576-.384a.236.236 0 0 1 .262 0l.576.384.353-.236 1.461-3.887c.129-.343.081-.727-.127-1.028zm-1.923 4.328-.46-1.414.448-.146.46 1.414-.448.146zm.69-1.65-.46-1.413.448-.146.46 1.414-.447.146z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "245anw3iaa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.4 4.402)",
    d: "M0 0h13.2v13.2H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hf46un8sqb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.4 4.402)",
    d: "M0 0h13.2v13.2H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroceryDelivery);
export default __webpack_public_path__ + "static/media/grocery-delivery.a3f68978.svg";
export { ForwardRef as ReactComponent };